<template>

    <ul class='tabBox'
        v-if="durationList.length>1"
        :style="{ justifyContent: align || 'center' }"
        ref="tabBox"
    >
        <!-- 滑动指示器 -->
        <div class="tabIndicator" :style="indicatorStyle"></div>

        <li class='tabItem'
            :class="{
                active: index === activeDurationIndex,
                'show-discount': checkItemShowDiscount(item)
            }"
            v-for='(item,index) in durationList'
            :key='index'
            @click='handleDurationChange(index)'
            :ref="'tabItem' + index"
        >
            <p>
                {{ item.title }}
                <span v-if="checkItemShowDiscount(item)">
                    ({{ yearPlansMaxDiscount }})
                </span>
            </p>
        </li>
    </ul>
</template>

<script lang="ts">
import { IDuration } from '@reolink-cloud/interface';
import Vue, { PropType } from 'vue';

export default Vue.extend({
    props:{
        durationList: Array as PropType<IDuration[]>,
        activeDurationIndex: Number,
        yearPlansMaxDiscount: String,
        align: String
    },
    data() {

        return {
            indicatorLeft: 0,
            indicatorWidth: 0,
            resizeTimer: null as any
        };

    },
    computed: {
        indicatorStyle() {

            return {
                transform: `translateX(${this.indicatorLeft}px)`,
                width: `${this.indicatorWidth}px`
            };

        }
    },
    mounted() {

        this.$nextTick(() => {

            this.updateIndicatorPosition();

        });

        // 监听窗口大小变化，解决pad横屏切换时的显示问题
        window.addEventListener( 'resize', this.handleResize );

    },
    beforeDestroy() {

        // 清理事件监听器
        window.removeEventListener( 'resize', this.handleResize );

    },
    watch: {
        activeDurationIndex() {

            this.$nextTick(() => {

                this.updateIndicatorPosition();

            });

        }
    },
    methods:{
        handleDurationChange( index: number ) {

            this.$emit( 'change', index );

        },
        updateIndicatorPosition() {

            const activeTabRef = this.$refs[`tabItem${this.activeDurationIndex}`];
            if ( activeTabRef?.[0] ) {

                const activeTab = activeTabRef[0] as HTMLElement;
                const tabBox = this.$refs.tabBox as HTMLElement;

                if ( tabBox ) {

                    const tabBoxRect = tabBox.getBoundingClientRect();
                    const activeTabRect = activeTab.getBoundingClientRect();

                    this.indicatorLeft = activeTabRect.left - tabBoxRect.left;
                    this.indicatorWidth = activeTabRect.width;

                }

            }

        },
        handleResize() {

            // 使用防抖来避免频繁更新
            clearTimeout( this.resizeTimer );
            this.resizeTimer = setTimeout(() => {

                this.$nextTick(() => {

                    this.updateIndicatorPosition();

                });

            }, 100 );

        },
        checkItemShowDiscount( item: IDuration ) {

            return this.yearPlansMaxDiscount && item.unit === 'year' && item.amount === 1;

        }
    },
});
</script>

<style lang="less" scoped>
.tabBox{
    user-select: none;
    margin: 0 0px 24px 0px;
    display: flex;
    background-color: @fill_tertiary;
    padding: 4px;
    border-radius: @border-radius-level-small;
    align-items: center;
    cursor: pointer;
    gap: 4px;
    max-width: fit-content;
    align-items: center;
    position: relative;
    .mobile({
        margin-left: 0;
        margin-right: 0;
        max-width: 100%;
        flex: 1;
    });

    .tabIndicator {
        position: absolute;
        top: 4px;
        left: 0;
        height: calc(100% - 8px);
        background: @white;
        border-radius: @border-radius-level-small;
        transition: transform 0.3s ease, width 0.3s ease;
        z-index: 1;
    }

    .tabItem{
        text-align: center;
        box-sizing: border-box;
        padding: 11px 50px;
        white-space: nowrap;
        position: relative;
        z-index: 2;
        .mobile({
            flex: 1;
            white-space: wrap;
            padding: 11px 4px;
        });

        &.active{
            color: @theme;
        }
        &.show-discount{
            .mobile({
                flex: 2;
            })
        }
        @media @pc{
            &:last-child{
                border-right: 0;
            }
        }
        p{
            font-size: 14px;
            line-height: 18px;
            align-self: center;
            font-weight: 500;
        }
    }

}
</style>
